import React from 'react'
import { Box, Typography } from '@mui/material'

import { formatFillRateProductTableDifference } from '../helpers/fillRateProductDifferencesFormatters'
import {
  FILL_RATE_PRODUCT_EMPTY_DIFFERENCE_SX,
  getFillRateProductDifferenceBadgeSx
} from '../style/fillRateProductDifferencesStyles'

const FillRateProductDifferenceCell = ({ value }) => {
  if (!value) {
    return (
      <Typography component="span" sx={FILL_RATE_PRODUCT_EMPTY_DIFFERENCE_SX}>
        -
      </Typography>
    )
  }

  return (
    <Box component="span" sx={getFillRateProductDifferenceBadgeSx(value)}>
      {formatFillRateProductTableDifference(value)}
    </Box>
  )
}

export default FillRateProductDifferenceCell
